/**
 * Two-letter initials for the avatar components (`GaiaAvatar`,
 * `GaiaAvatarStack`, `GaiaParticipantRow`, `GaiaRecipientCard`,
 * `GaiaPickerOption`). Those components take `initials` as a prop rather than
 * deriving them, so the rule lives here once instead of in every caller.
 *
 * Splits on whitespace and dots, so "Tom Weiß" → "TW" and
 * "janina.moellmann" → "JM".
 */
export function initialsOf(name: string | null | undefined): string {
  const parts = (name ?? '')
    .split(/[\s.]+/)
    .map(part => part.trim())
    .filter(Boolean);

  if (parts.length === 0) {
    return '?';
  }

  return parts
    .map(part => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}
